import React, { Fragment } from "react";
import Countdown from "react-downcount";

function Num2String(num) {
  const numStr = num > 9 ? Number(num).toString() : `0` + num;
  return numStr.split('');
}

const countdownRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  const times = [{
    value: Num2String(days),
    unit: 'DAYS'
  }, {
    value: Num2String(hrs),
    unit: 'HOURS'
  }, {
    value: Num2String(mins),
    unit: 'MINUTES'
  }, {
    value: Num2String(secs),
    unit: 'SECONDS'
  }]

  return (
    <Fragment>
      {
        times.map((time, index) => (
          <Fragment key={time.unit}>
             { index !== 0 ?  <div className="colon"></div> : null}
            <div className="countdown-time">
              {  time.value.map((num, index) => <span className="num" key={num + index}>{num}</span>) }
              <p className="unit">{time.unit}</p>
            </div>
          </Fragment>
        ))
      }
    </Fragment>
  );
};

const CustomCountdown = ({ endDate }) =>(
  <Countdown className="countdown" endDate={endDate}>
    {countdownRenderer}
  </Countdown>
)

export default CustomCountdown;
